import { Connection, PublicKey, SystemProgram } from '@solana/web3.js'

import { JsonRpcProvider } from 'ethers'
import { isEmpty } from 'lodash-es'

export const isEvmContractAddress = async (address: string, provider: JsonRpcProvider) => {
  let contractCode
  try {
    contractCode = await provider.getCode(address)
  } catch {
    contractCode = null
  }
  const isContractAddress = contractCode && contractCode !== '0x' && contractCode !== '0x0'
  return isContractAddress
}

export const isSolanaContractAddress = async (address: string, connection: Connection) => {
  let accountInfo
  const systemProgram = SystemProgram.programId.toBase58()
  try {
    const publicKey = new PublicKey(address)
    accountInfo = await connection.getAccountInfo(publicKey)
    return isEmpty(accountInfo) ? false : accountInfo?.executable || accountInfo?.owner?.toBase58() !== systemProgram
  } catch {
    return false
  }
}
